import { render } from "./user_agreement_ios.vue?vue&type=template&id=bfce1ef2&scoped=true"
import script from "./user_agreement_ios.vue?vue&type=script&lang=js"
export * from "./user_agreement_ios.vue?vue&type=script&lang=js"

import "./user_agreement_ios.vue?vue&type=style&index=0&id=bfce1ef2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfce1ef2"]])

export default __exports__